module.exports = __webpack_public_path__ + "img/unsecured-test.dd156026.jpg";